import React from "react";
import ClientPicture from "./ClientPicture";
import { Link } from "react-router-dom";
import { setNotificationReadState, getClient } from "../firebase/firestore";
import IconButton from "./IconButton";

class NotificationItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { clientData: null };
  }

  componentDidMount() {
    const { clientId, account } = this.props;

    getClient(
      account.id,
      clientId,
      client => {
        this.setState({ clientData: client.data() });
      },
      error => {}
    );
  }

  setReadState(state) {
    const { account } = this.props;
    setNotificationReadState(account.id, this.props.id, state);
  }

  render() {
    const { index, account } = this.props;
    const { clientData } = this.state;

    if (!clientData) {
      return null;
    }

    const status =
      this.props.type === "good"
        ? " NotificationItem-Good"
        : this.props.type === "waiting"
          ? " NotificationItem-Waiting"
          : " NotificationItem-Bad";

    const read = this.props.read ? " NotificationItem-Read" : "";
    const readIcon = this.props.read ? "eye" : "eye-slash";

    return (
      <div
        className={"NotificationItem" + status + read}
        style={{ animationDelay: `${index * 0.1}s` }}
      >
        <ClientPicture big clientId={this.props.clientId} account={account} />
        <div className="Divider" />
        <div className="MainStack">
          <p id="Title">{clientData.name}</p>
          <p id="Content">{this.props.message}</p>
          <Link className="Link" to={this.props.actionUrl}>
            {this.props.action}
          </Link>
        </div>
        <div className="NotifyRightStack">
          <IconButton
            id="ReadBtn"
            icon={readIcon}
            onClick={() => this.setReadState(!this.props.read)}
          />
          <p id="Time">{this.props.time}</p>
        </div>
      </div>
    );
  }
}

export default NotificationItem;



// WEBPACK FOOTER //
// ./src/components/NotificationItem.js